export const API_BASE_URL = process.env.REACT_APP_API_DOMAIN;

//Auth
export const EP_LOGIN = "/api/auth/login";
export const EP_CHANGE_USERNAME = "/api/auth/change-username";
export const EP_REFRESH_TOKEN = "/api/auth/refresh-token";
export const EP_RESET_PSSSOWRD = "/api/auth/reset-password";
export const EP_TOGGLE_ACCOUNT_ACTIVATE = "/api/auth/toggle-account-activate";

//Account
export const EP_CREATE_ACCOUNT = "/api/account/create";
export const EP_CHANGE_PASSOWRD = "/api/account/change-password";
export const EP_ADMIN_ACCOUNTS = "/api/account/admin-accounts";

//Shop
export const EP_SHOP_LIST = "/api/shop/shops";
export const EP_ADD_SHOP = "/api/shop/add";
export const EP_EDIT_SHOP = "/api/shop/edit";
export const EP_DELETE_SHOP = "/api/shop/delete";

//Category
export const EP_CREATE_CATEGORY = "/api/category/create";
export const EP_EDIT_CATEGORY = "/api/category/edit";
export const EP_TOGGLE_CATEGORY_ACTIVATE = "/api/category/toggle-activate";
export const EP_GET_CATEGORY_LIST = "/api/category/all";
export const EP_GET_ACTIVE_CATEGORY_LIST = "/api/category/active-categories";

//Product
export const EP_CREATE_PRODUCT = "/api/product/create";
export const EP_GET_PRODUCT_DETAILS = "/api/product/details";
export const EP_GET_EDIT_PRODUCT_DETAILS = "/api/product/edit-details";
export const EP_GET_ACTIVE_PRODUCTS = "/api/product/active-products";
export const EP_GET_INACTIVE_PRODUCTS = "/api/product/inactive-products";
export const EP_EDIT_PRODUCT = "/api/product/edit";
export const EP_TOGGLE_ACTIVATE_PRODUCT = "/api/product/toggle-activate";

//Purchase
export const EP_GET_PRODUCT_TO_PURCHASE = "/api/purchase/purchased-product";
export const EP_PURCHASE_PRODUCT = "/api/purchase/save";
export const EP_GET_PURCHASE_PRODUCTS = "/api/purchase/purchased-products";
export const EP_GET_PURCHASE_DETAILS = "/api/purchase/details";
export const EP_GET_EDIT_PURCHASE_INFO = "/api/purchase/edit-info";
export const EP_EDIT_PURCHASE = "/api/purchase/edit";
export const EP_RECEIVED_PURCHASE = "/api/purchase/received";
export const EP_CANCELLED_PURCHASE = "/api/purchase/cancelled";

//Order
export const EP_ORDER_AVAILABLE_PRODUCTS = "/api/order/available-products";
export const EP_ADD_NEW_ORDER = "/api/order/add";
export const EP_EDIT_ORDER = "/api/order/edit";
export const EP_EDIT_DELI_INFO = "/api/order/deli-edit";
export const EP_ORDER_DETAILS_TO_EDIT = "/api/order/to-edit";
export const EP_ORDER_DETAILS = "/api/order/details";
export const EP_GET_ORDER_LIST = "/api/order/all";
export const EP_CANCEL_ORDER = "/api/order/cancel";
export const EP_FINISH_ORDER = "/api/order/finish";

//Management
export const EP_GET_MONTHLY_REPORTS = "/api/management/locked-reports";
export const EP_LOCK_FINANCE = "/api/management/lock-finance";
export const EP_GET_DASHBOARD = "/api/management/dashboard";
export const EP_GET_PROFIT_LOSS_CALCULATE = "/api/management/profit-loss";
export const EP_GET_POSTED_LINKS = "/api/management/posted-links";

//Common
export const EP_ALL_ACTIVE_USERS = "/api/common/active-admins";
export const EP_GET_LAST_LOCKED_YEAR_MONTH = "/api/common/last-lock";

//GeneralExpend
export const EP_ADD_GENERAL_EXPEND = "/api/generalExpend/add";
export const EP_DETAILS_GENERAL_EXPEND = "/api/generalExpend/details";
export const EP_EDIT_GENERAL_EXPEND = "/api/generalExpend/edit";
export const EP_CANCEL_GENERAL_EXPEND = "/api/generalExpend/cancel";
export const EP_GET_GENERAL_EXPENDS = "/api/generalExpend/general-expends";

//Money Adjustment
export const EP_ADD_MONEY_ADJUSTMENT = "/api/moneyAdjustment/add";
export const EP_DETAILS_MONEY_ADJUSTMENT = "/api/moneyAdjustment/details";
export const EP_EDIT_MONEY_ADJUSTMENT = "/api/moneyAdjustment/edit";
export const EP_CANCEL_MONEY_ADJUSTMENT = "/api/moneyAdjustment/cancel";
export const EP_GET_MONEY_ADJUSTMENTS = "/api/moneyAdjustment/money-adjustments";

//Print PDF
export const EP_GET_PRINT_PURCHASE_INFOS = "/api/printPDF/print-purchase-infos";
export const EP_GET_PRINT_ORDER_INFOS = "/api/printPDF/print-order-infos";
export const EP_GET_PRINT_INSTOCKS = "/api/printPDF/print-instocks";

//Instock Adjustment
export const EP_GET_OUTOFSTOCKS = "/api/instockAdjustment/out-of-stocks";
export const EP_GET_INSTOCK_LIST = "/api/instockAdjustment/instocks";
export const EP_TOGGLE_STOCK_ADJUSTED_FLAG = "/api/instockAdjustment/toggle-stock-adjusted";
export const EP_SEND_ITEM_TO_OTHER = "/api/instockAdjustment/send";
export const EP_GET_SEND_ITEM_HISTORIES = "/api/instockAdjustment/send-histories";